import './VersionBadge.css'

// __APP_VERSION__ / __BUILD_SHA__ are injected at build time via Vite's
// `define` in vite.config.js (read from package.json + the deploy commit).
// Rendered outside <Routes> and outside the ErrorBoundary in App.jsx so it
// stays visible even on /login and even if a route crashes.
function VersionBadge() {
  return (
    <div className="version-badge" aria-label="Build version">
      <span>v{__APP_VERSION__}</span>
      <span className="version-badge-sep">·</span>
      <span className="version-badge-sha">{__BUILD_SHA__}</span>
    </div>
  )
}

export default VersionBadge
